/* ============
 * All License Groups
 * ============
 *
 * All license groups.
 */

import Vue from 'vue';
import store from '../../store';
import licensePermitTypeTransformer from '../../transformers/licensePermitType';

const success = ({ data }, resolve) => {
  const licensePermitTypes = licensePermitTypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllLicensePermitTypes', licensePermitTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display license groups.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('license/permit_types')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/licensePermitType/all.js